
export default function Footer() {
  const scrollToStores = () => {
    document.getElementById('reservation-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* 로고 및 소개 */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/bc658600574082ef42d46497448eb1f8.jpg" 
                alt="룸팡멤버쉽 로고" 
                className="h-8 w-auto"
              />
              <h3 className="text-xl font-extrabold text-white">룸팡멤버쉽</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed font-medium">
              간편하고 빠른 예약 서비스를 제공합니다. 원하시는 매장을 선택하고 편리하게 예약하세요.
            </p>
          </div>

          {/* 빠른 링크 */}
          <div>
            <h4 className="text-lg font-extrabold mb-4 text-white">빠른 링크</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={scrollToStores}
                  className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer font-semibold"
                >
                  홈
                </button>
              </li>
              <li>
                <button 
                  onClick={scrollToStores}
                  className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer font-semibold"
                >
                  예약하기
                </button>
              </li>
              <li>
                <a href="/login" className="text-white/80 hover:text-white text-sm transition-colors font-semibold">
                  로그인
                </a>
              </li>
              <li>
                <a href="/signup" className="text-white/80 hover:text-white text-sm transition-colors font-semibold">
                  회원가입
                </a>
              </li>
            </ul>
          </div>

          {/* 연락처 */}
          <div>
            <h3 className="text-lg font-extrabold mb-4 text-white">문의</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-lg text-cyan-400"></i>
                </div>
                <span className="text-white/80 text-sm font-semibold">010-8376-4375</span>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-lg text-cyan-400"></i>
                </div>
                <span className="text-white/80 text-sm font-semibold">연중무휴 24시간</span>
              </li>
            </ul>
          </div>

          {/* 소셜 미디어 */}
          <div>
            <h3 className="text-lg font-extrabold mb-4 text-white">소셜 미디어</h3>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors border border-white/20">
                <i className="ri-kakao-talk-fill text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors border border-white/20">
                <i className="ri-telegram-fill text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors border border-white/20">
                <i className="ri-instagram-fill text-white text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* 하단 */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/70 text-sm font-semibold">
              © 2024 룸팡멤버쉽. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer font-semibold"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
